import * as React from "react";
import { SectionCommon } from "./layout/section-common";
import ElevateIcon from "../svgs/elevate.svg";
import styled from "@emotion/styled";
import { breakpoints } from "../styles/breakpoints";
import { ArrowButton } from "./arrow-button";

const StyledElevate = styled.div`
  .img {
    margin: var(--medium) auto;

    @media (max-width: ${breakpoints.lg}) {
      width: 220px;
    }
  }
`;

export const Elevate = () => (
  <SectionCommon
    title="Elevate Your Agency
		to New Heights"
    text="Fast-growing agencies in all industries and niches choose Agency Elevation to reach the next level."
  >
    <StyledElevate>
      <img
        className="img"
        src={ElevateIcon}
        alt="Elevate Your Agency to New Heights"
      />
      <ArrowButton href="/results" text="See results" />
    </StyledElevate>
  </SectionCommon>
);
